import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";

export default function NeedDocumentation({
  searchObject,
  t,
  setSearchObject
}) {
  function oncheckBoxCheked({ target }) {
    setSearchObject({
      ...searchObject,
      [target.name]: target.checked
    });
  }

  return (
    <div style={{ marginTop: "34px" }}>
      <input
        type="checkbox"
        checked={searchObject.needDocumentation}
        name="needDocumentation"
        onChange={oncheckBoxCheked}
        className="form-check-input"
      />
      <label
        className="form-check-label fontsize-legend"
        style={{ marginLeft: "10px" }}
      >
        {t("Need Documentation?")}
      </label>
    </div>
  );
}
